/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right-old': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M8.8 2.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l15 15c.4.4.4 1 0 1.4l-15 15c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L23.1 17 8.8 2.7z"/>'
  }
})
